import { LegalLayout, LegalSection, LegalNote } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

const PENDING_SECTIONS = [
  "B. Loan Appraisal & Terms",
  "C. Disbursement & Term Changes",
  "D. Interest Rates",
  "E. Grievance Redressal",
  "F. General Provisions",
  "G. Force Majeure",
  "H. Implementation",
];

export function FairPracticeCodePage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Fair Practice Code"
      description={`Committed to transparency, fairness, and ethical lending practices at ${siteConfig.companyName}.`}
    >
      <LegalSection heading="Background">
        <p>
          The Reserve Bank of India ("RBI") has issued guidelines on the
          Fair Practice Code for Non-Banking Finance Companies (NBFCs),
          setting standards for fair business and corporate practices while
          dealing with customers.
        </p>
        <p>
          {siteConfig.companyName} (hereinafter referred to as the
          "Company") adopts these guidelines and makes necessary
          modifications to this Code as required from time to time. The
          Company is committed to offering all financial products to
          eligible applicants without discrimination on grounds of race,
          caste, color, religion, sex, marital status, age, or disability.
        </p>
        <p>
          The Fair Practice Code (FPC) outlines procedures for business
          transactions and ensures fair treatment of borrowers.
        </p>
      </LegalSection>

      <LegalSection heading="A. Loan Applications & Processing">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <span className="font-semibold text-[#1c1917]">
              Multilingual Communication:
            </span>{" "}
            All communications in vernacular or a language understood by the
            borrower.
          </li>
          <li>
            <span className="font-semibold text-[#1c1917]">
              Clear Application Forms:
            </span>{" "}
            Includes all key information and required documents for
            informed decisions.
          </li>
          <li>
            <span className="font-semibold text-[#1c1917]">
              Acknowledgment & Timeline:
            </span>{" "}
            Every application is acknowledged with a decision timeline.
          </li>
        </ul>
      </LegalSection>

      {PENDING_SECTIONS.map((heading) => (
        <LegalSection key={heading} heading={heading}>
          <LegalNote>
            Content for this section is pending and will be published once
            finalized.
          </LegalNote>
        </LegalSection>
      ))}
    </LegalLayout>
  );
}
